import { callHandlers } from './callHandlers';
export function composeHandlers(handlers) {
    return function (event) {
        callHandlers(event, handlers);
    };
}
